import { render, staticRenderFns } from "./EmployeeVoiceForm.vue?vue&type=template&id=76eb9d66&"
import script from "./EmployeeVoiceForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeVoiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports